export default __webpack_public_path__ + "static/WorkSans-Bold-ddc4c7a34f3a880cdd680db6001df22a.woff";